module.exports = __webpack_public_path__ + "static/media/peterpitch.fa97bffc.png";